<template>
  <div class="fccPublicacoesTVisualizacao">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            addFilter
            :items="listagemApresentacao"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldModal"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="
            criarTipo.idPublicacaoParametroTipo === 0
              ? adicionaParametroPadraoTipo()
              : editandoTipoApresentacao()
          "
        >
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="criarTipo.tipoParametro"
                >Tipo de Parametro</fccInput
              >
            </div>
          </div>

          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Parâmetros padrão de tipos',
      titlePDF: 'Lista de Tipo de apresentação',
      titleModal: '',
      fields: [
        { key: 'idpublicacaoparametrotipo', label: 'Id', sortable: false },
        { key: 'tipoparametro', label: 'Tipo Parâmetro', sortable: true },
        { key: 'actions', label: '' }
      ],
      itemPorPage: '100',
      listagemApresentacao: [],
      criarTipo: {},
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteParametroPadraoTipo',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    listarParametroPadraoTipo: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao + 'PublicacaoParametroPadraoTipo/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemApresentacao = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    deleteParametroPadraoTipo: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.tipoparametro).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlPublicacao +
                'PublicacaoParametroPadraoTipo/Excluir/' +
                item.idpublicacaoparametrotipo,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarParametroPadraoTipo()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    editField: function (_, item) {
      this.criarTipo = {
        idPublicacaoParametroTipo: item.idpublicacaoparametrotipo,
        tipoParametro: item.tipoparametro
      }
      this.titleModal = 'Editar tipo de Parâmetro'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    addField: function () {
      this.criarTipo = {}
      this.criarTipo.idPublicacaoParametroTipo = 0
      this.titleModal = 'Adicionar tipo de Parâmetro'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    changeTStatus: function (_, item) {
      this.criarTipo = item
      this.editandoTipoApresentacao()
    },
    editandoTipoApresentacao: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlPublicacao + 'PublicacaoParametroPadraoTipo/AlterarPublicacaoParametroPadrao',
          this.criarTipo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarParametroPadraoTipo()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionaParametroPadraoTipo: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoParametroPadraoTipo/Inserir',
          this.criarTipo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarParametroPadraoTipo()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarParametroPadraoTipo()
  }
}
</script>
